module.exports = require('./internal/FixedDataTableRoot');



//////////////////
// WEBPACK FOOTER
// ./~/fixed-data-table-2/main.js
// module id = 192
// module chunks = 0